module.exports = __webpack_public_path__ + "static/media/pr_01_B.ce2a63a6.png";